export default __webpack_public_path__ + "static/media/como_funciona_01.a7beff23.png";